module.exports = __webpack_public_path__ + "static/media/logo-data-management.8bf8d9e8.svg";